
import React from 'react'
import icon from './svgs/TimeHistory2.svg'
import { BaseIcon } from './_base'

export const TimeHistory2Icon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon={icon} {...{fontSize,size,...sx}} />
    )
}
